import React from 'react';
import type { EacReportSummaryItem } from '../../../api';
import type { EacDisplayMode } from '../types';
import { formatCommonNumber, formatThousandNumber } from '../utils';

interface EacReportTableProps {
  rows: EacReportSummaryItem[];
  displayMode: EacDisplayMode;
}

/** EAC 汇总表：固定双层表头 + 两段区间（3-9 / 10-12）展示。 */
const EacReportTable: React.FC<EacReportTableProps> = ({
  rows,
  displayMode,
}) => {
  const renderSummaryCellValue = (
    row: EacReportSummaryItem,
    phase: 'actual' | 'estimated'
  ) => {
    if (displayMode === 'hours') {
      const value = phase === 'actual' ? row.actualHours : row.estimatedHours;
      return formatCommonNumber(value);
    }

    const costValue = phase === 'actual' ? row.actualCost : row.estimatedCost;
    return formatThousandNumber(costValue);
  };

  return (
    <section className="mt-2 w-full max-w-[1080px] lg:max-w-[1160px] 2xl:max-w-[1280px]">
      <div className="mb-[1px] flex items-end justify-between">
        <div className="flex items-end">
          <button
            type="button"
            className="h-8 min-w-[74px] cursor-pointer rounded-t border border-solid border-b-0 border-[#2f67ef] bg-white px-5 text-[14px] text-[#2f67ef]"
          >
            Labor
          </button>
          <button
            type="button"
            disabled
            className="ml-1 h-8 min-w-[84px] cursor-not-allowed rounded-t border border-solid border-b-0 border-[#c9d1dc] bg-[#f3f4f6] px-5 text-[14px] text-[#6b7280]"
          >
            Non-Labor
          </button>
        </div>

        <div className="pb-2 text-xs text-[#6b7280]">
          假定当前为2026年10月1日
        </div>
      </div>

      <div className="overflow-hidden bg-white">
        <table className="w-full border-collapse text-[14px] text-[#374151] lg:text-[13px]">
          <thead>
            <tr className="bg-[#f6f7f7]">
              <th
                className="w-[220px] border border-solid border-[#c9d1dc] px-3 py-2 text-left font-normal"
                rowSpan={2}
              >
                Position
              </th>
              <th
                className="w-[160px] border border-solid border-[#c9d1dc] px-3 py-2 text-left font-normal"
                rowSpan={2}
              >
                Name
              </th>
              <th
                className="border border-solid border-[#c9d1dc] px-2 py-2 text-center font-normal"
                colSpan={10}
              >
                2026
              </th>
            </tr>
            <tr className="bg-[#f6f7f7]">
              {['3', '4', '5', '6', '7', '8', '9', '10', '11', '12'].map(
                month => (
                  <th
                    key={month}
                    className="border border-solid border-[#c9d1dc] px-2 py-1.5 text-center font-normal"
                  >
                    {month}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td
                  colSpan={12}
                  className="border border-solid border-[#c9d1dc] px-3 py-8 text-center text-[14px] text-[#9ca3af]"
                >
                  No data
                </td>
              </tr>
            ) : (
              rows.map(row => (
                <tr key={row.id}>
                  <td className="border border-solid border-[#c9d1dc] px-3 py-2.5">
                    {row.job}
                  </td>
                  <td className="border border-solid border-[#c9d1dc] px-3 py-2.5">
                    {row.name}
                  </td>
                  <td
                    className="border border-solid border-[#c9d1dc] bg-[#bce1ff] px-2 py-2.5 text-center"
                    colSpan={7}
                  >
                    {renderSummaryCellValue(row, 'actual')}
                  </td>
                  <td
                    className="border border-solid border-[#c9d1dc] bg-[#aeeabd] px-2 py-2.5 text-center"
                    colSpan={3}
                  >
                    {renderSummaryCellValue(row, 'estimated')}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default EacReportTable;
